<script lang="ts">
    export let title: string = ''
    export let label: string = ''
    export let h: number = 5
</script>

<div class="zinput_title">
    <!-- <svelte:element this={`h${h}`}>
        {title}
    </svelte:element> -->

    <div class="zinput_title_headline">{title}</div>
    <div class="zinput_title_label">{label}</div>
</div>

<style>
    .zinput_title {
        flex-grow: 1;
        width: 100%;
        opacity: 0.8;
        margin-top: 16px;
    }
    .zinput_title_headline {
        font-size: 18px;
    }
    .zinput_title_label {
        opacity: 0.8;
        margin-top: -4px;
        font-weight: 300;
        font-size: 15px;
    }
</style>
